/**
 * @generated SignedSource<<5d414352214d97f05bb1268032a1d2ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TqlEntity = "CUSTOM_FIELD" | "DIRECTORY_VIEW" | "GOAL" | "HELP_POINTER" | "KUDOS" | "LEARNING" | "PERSON" | "PROJECT" | "TAG" | "TEAM" | "UNKNOWN";
export type TqlExplainerQuery$variables = {
  containerId?: string | null;
  directoryViewUuid?: string | null;
  entity: TqlEntity;
  hasTqlOrViewUuid: boolean;
  tql?: string | null;
  workspaceUuid?: string | null;
};
export type TqlExplainerQuery$data = {
  readonly explainTql?: {
    readonly explanation: string | null;
  } | null;
};
export type TqlExplainerQuery = {
  response: TqlExplainerQuery$data;
  variables: TqlExplainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTqlOrViewUuid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v6 = [
  {
    "condition": "hasTqlOrViewUuid",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "directoryViewUuid",
            "variableName": "directoryViewUuid"
          },
          {
            "kind": "Variable",
            "name": "entity",
            "variableName": "entity"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "tql"
          },
          {
            "kind": "Variable",
            "name": "workspaceUuid",
            "variableName": "workspaceUuid"
          }
        ],
        "concreteType": "TQLExplanation",
        "kind": "LinkedField",
        "name": "explainTql",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "explanation"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TqlExplainerQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TqlExplainerQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "376708c771601a197c66be06adf45bef",
    "id": null,
    "metadata": {},
    "name": "TqlExplainerQuery",
    "operationKind": "query",
    "text": "query TqlExplainerQuery(\n  $tql: String\n  $entity: TqlEntity!\n  $directoryViewUuid: UUID\n  $workspaceUuid: UUID\n  $containerId: String\n  $hasTqlOrViewUuid: Boolean!\n) {\n  explainTql(q: $tql, entity: $entity, directoryViewUuid: $directoryViewUuid, workspaceUuid: $workspaceUuid, containerId: $containerId) @include(if: $hasTqlOrViewUuid) {\n    explanation\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e53a196ccb76025b906b0341682f647";

export default node;
